import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import { LondonDate, formatDate, validateForm } from "../../Utils/utils";
import PriceSelect from "../../Components/CMS/PriceSelect";
import ApiService from "../../Core/Service/ApiService";

const HomePreview = React.memo(props=>{
    const [organizations, setOrganizations] = useState([]);
    const [branches, setBranches] = useState([]);
    const [formData, setFormData] = useState({
        date: LondonDate(new Date()),
        price_list: ['999']
    });
    const formDataRef = useRef(formData);
    const [previewUrl, setPreviewUrl] = useState();
    const rules = {
        branch: {
            required: 'number',
        },
        price_list: {
            required: 'array'
        },
        organization: {
            required: 'number'
        }
    }
    const [inputErrors, setInputErrors] = useState({});

    const loadData = async() => {
        let response;

        // To load organizations
        response = await ApiService.get('/organizations/all');
        const orgs = response.data.organizations;
        setOrganizations(orgs?.map(org=>({
            value: org.id, 
            label: org.name
        })));

        // To load branches
        response = await ApiService.get('/branches/all');
        const brs = response.data.branches;
        setBranches(brs?.map(br=>({
            value: br.id,
            label: br.site_name,
        })));

        setFormData({
            ...formData,
            organization: (orgs?.length > 0) ? orgs[0].id : '',
            branch: (brs?.length > 0) ? brs[0].id : '',
        })

        setTimeout(() => {
            previewIframe();  
        }, 1000);
    }
    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        formDataRef.current = formData;
        const ret = validateForm(formData, rules);
        setInputErrors(ret.errors);
    }, [formData]);

    const previewIframe = () => {
        const ret = validateForm(formDataRef.current, rules);
        if(ret.result) {
            setInputErrors({});

            let url = `${process.env.REACT_APP_ORDER_SITE_URL}/home/preview?`;
            const data = {
                date: formatDate(formDataRef.current.date, 'YYYY-MM-DD hh:mm'),
                price_list: formDataRef.current.price_list?.join(',') ?? [],
                branch: formDataRef.current.branch ?? '',
                organization: formDataRef.current.organization ?? '',
            }
            const params = new URLSearchParams(data).toString();
            url += params; console.log(url)
            setPreviewUrl(url);
        } else {
            setInputErrors(ret.errors);
        }
    };

    const previewNewWindow = () => {
        const ret = validateForm(formData, rules);
        if(ret.result) {
            setInputErrors({});

            let url = `${process.env.REACT_APP_ORDER_SITE_URL}/home/preview?`;
            const data = {
                date: formatDate(formData.date, 'YYYY-MM-DD hh:mm'),
                price_list: formData.price_list?.join(',') ?? [],
                branch: formData.branch ?? '',
                organization: formData.organization ?? '',
            }
            const params = new URLSearchParams(data).toString();
            url += params; console.log(url)
            window.open(url);
        } else {
            setInputErrors(ret.errors);
        }
    }

    const handleDateChange = (date, target) => {
        setFormData({
            ...formData,
            [target]: date
        });
    }
    const handleSelectChange = (opt, target) => {
        setFormData({
            ...formData,
            [target]: opt.value,
        })
    }
    const handlePriceChange = (price_list) => {
        setFormData({
            ...formData,
            price_list
        })
    }

    return (
    <div className="home-preview">
        <MDBCard>
            <MDBCardHeader>
                <MDBCardTitle>Filter</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <div className="d-flex">
                    <div className="me-4">
                        <label className="me-2 required">Date:</label>
                        <div>
                            <DateTimePicker 
                                value={formData.date}
                                onChange={d=>handleDateChange(d, 'date')} 
                            />
                        </div>
                    </div>
                    <div className="me-4">
                        <label className="me-2 required">Organization:</label>
                        <div style={{width: 200}}>
                            <Select 
                                options={organizations} 
                                value={organizations.find(opt=>opt.value==formData.organization)} 
                                onChange={opt=>handleSelectChange(opt, 'organization')} 
                            />
                        </div>
                        {inputErrors?.organization && <div className="error">{inputErrors.organization}</div>}
                    </div>
                    <div className="me-4">
                        <label className="me-2 required">Branch:</label>
                        <div style={{minWidth: 200}}>
                            <Select
                                options={branches}
                                value={branches.find(opt=>opt.value==formData.branch)}
                                onChange={opt=>handleSelectChange(opt, 'branch')}
                            />
                        </div>
                        {inputErrors?.branch && <div className="error">{inputErrors.branch}</div>}
                    </div>
                </div>
                <PriceSelect
                    className="mt-4" 
                    initialSelectedPrices={formData.price_list} 
                    onChange={handlePriceChange} 
                    required={true}
                    inputError={inputErrors?.price_list}
                />
                <div className="mt-4 d-flex justify-content-end">
                    <MDBBtn color="success" onClick={previewNewWindow} className="me-4">Preview In New Window</MDBBtn>
                    <MDBBtn color="primary" onClick={previewIframe}>Preview In IFrame</MDBBtn>
                </div>
            </MDBCardBody>
        </MDBCard>

        <div className="mt-4">
            <iframe
                src={previewUrl}
                style={{width: '100%', height: '100vh'}}
            />
        </div>
    </div>
    )
});

export default HomePreview;